import React from "react";
import { render } from "react-dom";

import InnerReference from "@components/daily/InnerReference";

export default () => {
  document.getElementById("js-internal-contianer") &&
    render(
      <InnerReference />,
      document.getElementById("js-internal-contianer")
    );
  const $window = $(window);

  $window.on("scroll", () => {
    if (
      Math.ceil($window.scrollTop() + $window.height() + 30) >
      Math.ceil($("body").height())
    ) {
      $(".js-daily-bar").addClass("is-bottom");
    } else {
      $(".js-daily-bar").removeClass("is-bottom");
    }
  });

  $window.scroll();
};
